import React, { Component } from "react";
import { Portal } from "react-portal";
import GravityForm from "react-gravity-form";

export default class RequestInspection extends Component {
	
	constructor(){
		super()
		this.state = {
			active: 0,
			open:false
		}
		this.handleToggle 	= this.handleToggle.bind(this);
	}
  	
	handleToggle() { 
    	this.setState({ open: !this.state.open });
  	};
  	
  	
  	  			
	render() {
		
		let address 		= this.props.address;
		let bd_project_id 	= this.props.bd_project_id;
		
		let modalClass 		= 'c-enquire';
		if (this.state.open === true) {
			modalClass 		= 'c-enquire state-open';
		}	
		
		const queryString 	= window.location.search;
		const urlParams 	= new URLSearchParams(queryString);
		
		let utmCampaign = '';
		if (urlParams.get('utm_campaign')) {
			utmCampaign = urlParams.get('utm_campaign');
		} else if (urlParams.get('utm-campaign')) {
			utmCampaign = urlParams.get('utm-campaign');
		}
		
		let utmTerm = '';
		if (urlParams.get('utm_term')) {
			utmTerm = urlParams.get('utm_term');
		} else if (urlParams.get('utm-term')) {
			utmTerm = urlParams.get('utm-term');
		}
		
		let utmMedium = '';
		if (urlParams.get('utm_medium')) {
			utmMedium = urlParams.get('utm_medium');
		} else if (urlParams.get('utm-medium')) {
			utmMedium = urlParams.get('utm-medium');
		}
		
		let utmSource = '';
		if (urlParams.get('utm_source')) {
			utmSource = urlParams.get('utm_source');
		} else if (urlParams.get('utm-source')) {
			utmSource = urlParams.get('utm-source');
		}
		
		let utmContent = '';
		if (urlParams.get('utm_content')) {
			utmContent = urlParams.get('utm_content');
		} else if (urlParams.get('utm-content')) {
			utmContent = urlParams.get('utm-content');
		}
		
		let campaignID = '';
		if (urlParams.get('campaign_id')) {
			campaignID = urlParams.get('campaign_id');
		} else if (urlParams.get('campaign-id')) {
			campaignID = urlParams.get('campaign-id');
		} else if (urlParams.get('campaignid')) {
			campaignID = urlParams.get('campaignid');
		}
		
		let gclid = '';
		if (urlParams.get('gclid')) {
			gclid = urlParams.get('gclid');
		}
		
		let fbclid = '';
		if (urlParams.get('fbclid')) {
			fbclid = urlParams.get('fbclid');
		}
		
		let sourceURL = window.location + '';
		sourceURL = sourceURL.split("?")[0].split("#")[0]

		return (				
			
			<>
				<div className="c-property__buttons__button c-property__buttons__button--right" onClick={this.handleToggle}>Make An Enquiry</div>
				<Portal>
					<div className={modalClass}>
						<div href="#" className="c-enquire__overlay" onClick={this.handleToggle}></div>
						<div className="c-enquire__panel">
							<div className="c-enquire__panel__inner">
								<div className="c-enquire__close" onClick={this.handleToggle}></div>
								<h4 className="c-enquire__heading" dangerouslySetInnerHTML={ {__html: 'Make An Enquiry' }}></h4>
								<h3 id="enquire-variant" className="c-enquire__subheading" dangerouslySetInnerHTML={ {__html: address}}></h3>
								<div className="c-enquire__form">
									<div className="scope-form">
										<GravityForm
											backendUrl={document.location.origin + '/wp-json/castran/v1/form'}
											formID={4}
											styledComponents={{}}
											populatedFields={{
												propertyAddress: 	address,
												utmCampaign: 		utmCampaign,
												utmTerm: 			utmTerm,
												utmMedium: 			utmMedium,
												utmSource: 			utmSource,
												utmContent: 		utmContent,
												campaignID: 		campaignID,
												gclid: 				gclid,
												fbclid: 			fbclid,
												projectID: 			bd_project_id,
												sourceURL: 			sourceURL,
												comments: 			address
											}}
										/>
									</div>
								</div>
							</div>
						</div>
					</div>
				</Portal>
			</>					
		);

	}
}